export default __webpack_public_path__ + "static/media/whiteMail.3f37ad6a.svg";